import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"
import GivenMapSection from "../../mainSections/GivenMapSection"
import AracDetails from "../../sections/yukDetails/AracDetails"
import RouteDetails from "../../sections/yukDetails/RouteDetails"
import YukDetails from "../../sections/yukDetails/YukDetails"
import OdemeDetails from "../../sections/yukDetails/OdemeDetails"
import Button from "../../../shared/Button"
import { useDispatch } from "react-redux"
import { showModal } from "../../../../features/modal/modalSlice"
import { setErrors } from "../../../../features/addLoad/addLoadSlice"
import submitLoadPermission from "../../../../helper/load/submitLoadPermissionUpdate"
import RoutesMapSection from "../../../load/mainSections/RoutesMapSection"

const Container = styled.div`
    width: 500px;
    position: relative;

    .wrapper{
        width: 500px;
        position: sticky !important;
        top: 0 !important;

        .map-side-content{
          padding: 5px 30px 20px 30px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          border-radius: 10px;
          background-color: ${({theme}) => theme.secondaryBgColor} !important;
        }

        .top{
          padding: 8px 0;

          h3{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            color: ${({theme}) => theme.mainTextColor};
          }
        }

        .map-container{
          width: 100%;
          height: 200px;
          border-radius: 10px;
        }

        .details-container{
          width: 100%;
          display: flex;
          flex-direction: column;
          overflow: auto;
          gap: 10px;
          padding-top: 10px;
          height: calc(100vh - 610px);

          &::-webkit-scrollbar {
            width: 5px;
          }
          &::-webkit-scrollbar-thumb {
              background-color: #9e9b9b;
              border-radius: 10px;
          }
          &::-webkit-scrollbar-track {
              background-color: transparent;
          }
        }
    }
`

const MapSide = ({yukEkle, kayitGuncelle}) => {

  const dispatch = useDispatch()

  const {aracData, yukData, paketlemeData, paymentData, route, routeDistance} = useSelector(state => state.updateLoad)

  const [routeList, setRouteList] = useState([])

  useEffect(() => {
    const list = route.map((item, i) => {
      if(i === 0 || i === route.length -1){
        return {lat: parseFloat(item.locationData.lat), lng: parseFloat(item.locationData.lng)}
      }
      else{
        return {location: {lat: parseFloat(item.locationData.lat), lng: parseFloat(item.locationData.lng)}}
      }
    }).filter((item) => {
        return (item?.lat && item?.lng) || (item?.location?.lat && item?.location?.lng)
    })

    setRouteList(list)
  },[route])
  
  const handleClick = () => {
    //! buradan true gelirse iyi false gelirse error verilmeli
    if(submitLoadPermission(route, aracData, paymentData, yukData, paketlemeData, routeDistance)){
      dispatch(showModal("addLoadYuklemeSecenekleri"))
    }
    else{
      dispatch(setErrors(true))
    }
      // dispatch(showModal("addLoadYuklemeSecenekleri"))
  }

  return (
    <Container>
        <div className="wrapper">
          <div className="map-side-content">
          <div className="top">
                <h3>Yüke İlişkin Detaylar</h3>
          </div>
          <div className="map-container">
          <RoutesMapSection
          from={"update"}
            route={route.map(item => {
              return {
                lat: parseFloat(item.locationData.lat.toString().replace(",", ".")),
                lng: parseFloat(item.locationData.lng.toString().replace(",", "."))
              }
            })} defaultLocation={{lat: 38.75, lng: 33.75}} zoom={5}/>
          </div>
          <div className="details-container">
            <RouteDetails route={route} routeDistance={routeDistance}/>
            <AracDetails aracData={aracData}/>
            <YukDetails yukData={yukData} paketlemeData={paketlemeData}/>
            <OdemeDetails odemeData={paymentData}/>
          </div>
          {/* {!kayitGuncelle && <Button color={"#fff"} background={"#E85546"} width="100%" radius={"10px"} text={"Tamamla"} fontSize="14px" handleClick={handleClick}/>} */}
            </div>
          </div>

    </Container>
  )
}

export default MapSide